"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var itemButtonStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        buttonWrapper: {
            padding: '15px',
        },
        button: {
            borderRadius: 0,
            borderColor: palette.primary.main,
            color: palette.primary.main,
            height: 40,
            maxWidth: '300px',
            padding: '0 40px',
            width: '100%',
        },
        isSelected: {
            backgroundColor: palette.primary.main,
            color: palette.common.white,
            '&:hover': {
                backgroundColor: palette.primary.main,
                '@media (hover: none)': {
                    backgroundColor: palette.primary.main,
                },
            },
        },
        buttonLabel: {
            fontSize: typography.fontXS,
            fontWeight: 600,
        },
        outlinedPrimary: {},
    });
}, { name: 'GqlCheckout_ExpressionsOfInterest_ItemButton' });
exports.default = itemButtonStyles;
